export default __webpack_public_path__ + "static/media/wuerthbook_webfont3_2.e19d373f.woff2";